import axios from 'axios';
import { createActionType } from 'utils/redux';

import { API_CONFIG } from 'constants/config';
import { handleErrors } from 'utils/api';
import { apiGetAccounts, apiUpdateAccount } from 'constants/apiRouting';
import { CREATE_ACCOUNT, UPDATE_ACCOUNT as UPDATE_ACCOUNT_EVENT, DESTROY_ACCOUNT } from 'constants/analytics';
import { analyticsTrack } from '../../utils/analytics';

// object
export const CREATE_ACCOUNT_PENDING = 'CREATE_ACCOUNT_PENDING';
export const CREATE_ACCOUNT_FAIL = 'CREATE_ACCOUNT_FAIL';
export const CREATE_ACCOUNT_SUCCESS = 'CREATE_ACCOUNT_SUCCESS';
export const GET_ACCOUNT_PENDING = 'GET_ACCOUNT_PENDING';
export const GET_ACCOUNT_FAIL = 'GET_ACCOUNT_FAIL';
export const GET_ACCOUNT_SUCCESS = 'GET_ACCOUNT_SUCCESS';
export const DESTROY_ACCOUNT_PENDING = 'DESTROY_ACCOUNT_PENDING';
export const DESTROY_ACCOUNT_FAIL = 'DESTROY_ACCOUNT_FAIL';
export const DESTROY_ACCOUNT_SUCCESS = 'DESTROY_ACCOUNT_SUCCESS';
export const UPDATE_ACCOUNT = createActionType('UPDATE_ACCOUNT');
// objects
export const GET_ACCOUNTS_PENDING = 'GET_ACCOUNTS_PENDING';
export const GET_ACCOUNTS_FAIL = 'GET_ACCOUNTS_FAIL';
export const GET_ACCOUNTS_SUCCESS = 'GET_ACCOUNTS_SUCCESS';


export const createAccount = (params = {
  name: null,
  email: null,
  products: null,
  industries: null,
  accepts_sponsorships: null,
}) => async (dispatch) => {
  analyticsTrack(CREATE_ACCOUNT, params, true);

  dispatch({
    type: CREATE_ACCOUNT_PENDING,
    payload: {},
  });
  try {
    const response = await axios.post(
      `${API_CONFIG.API_BASE}${API_CONFIG.API_VERSIONS.V1}accounts/`,
      params, { withCredentials: true },
    );
    dispatch({
      type: CREATE_ACCOUNT_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    handleErrors(error, dispatch);
  }
};


export const getAccount = accountId => async (dispatch) => {
  dispatch({
    type: GET_ACCOUNT_PENDING,
    payload: {},
  });
  try {
    const response = await axios.get(
      `${API_CONFIG.API_BASE}${API_CONFIG.API_VERSIONS.V1}accounts/${accountId}/`,
      { withCredentials: true },
    );
    dispatch({
      type: GET_ACCOUNT_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    handleErrors(error, dispatch);
  }
};


export const updateAccount = (
  accountId,
  params = {
    name: null,
    email: null,
    products: null,
    industries: null,
    accepts_sponsorships: null,
    email_delay: null,
    max_emails_to_a_contact_per_day: null,
    response_email_forwards: null,
    status: null,
  },
) => async (dispatch) => {
  analyticsTrack(UPDATE_ACCOUNT_EVENT, {
    account: accountId,
    ...params,
  }, true);

  await dispatch({
    type: UPDATE_ACCOUNT.name,
    payload: axios.patch(apiUpdateAccount(accountId), params, { withCredentials: true })
      .catch(error => handleErrors(error, dispatch)),
  });
};


export const destroyAccount = accountId => async (dispatch) => {
  analyticsTrack(DESTROY_ACCOUNT, {
    account: accountId,
  }, true);

  try {
    await axios.delete(
      `${API_CONFIG.API_BASE}${API_CONFIG.API_VERSIONS.V1}accounts/${accountId}/`,
      { withCredentials: true },
    );
  } catch (error) {
    handleErrors(error, dispatch);
  }
};


export const getAccounts = (
  params = {
    search: null,
    status: null,
    page: null,
    campaign__campaign_manager__id: null,
  },
  seamless = false,
) => async (dispatch) => {
  dispatch({
    type: GET_ACCOUNTS_PENDING,
    // we've disabled loading if 'seamless' option is present because we need seamless inline search
    payload: seamless ? { ...params, loading: false, loaded: true } : params,
  });

  try {
    const response = await axios.get(apiGetAccounts(), { params, withCredentials: true });
    dispatch({
      type: GET_ACCOUNTS_SUCCESS,
      payload: response.data,
    });
    return response.data;
  } catch (error) {
    handleErrors(error, dispatch);
  }
  return null;
};
